import React, { useState } from 'react';

import InfoOutline from '@react/react-spectrum/Icon/InfoOutline';
import Textfield from '@react/react-spectrum/Textfield';

import './DealRegistrationInput.scss';

const DR_PATTERN = /DR\d{6,}$/;

export default function DealRegistrationInput({ defaultValue, onChange }) {
  const [state, setState] = useState({ validation: null });

  const validate = (event) => {
    setState({
      ...state,
      validation: event.currentTarget.value.match(DR_PATTERN)
        ? 'valid'
        : 'invalid'
    });
  };

  return (
    <div className="deal-registration-input">
      <Textfield
        placeholder="e.g. DR123456"
        onChange={onChange}
        onBlur={validate}
        validationState={state.validation}
        defaultValue={defaultValue}
      />
      <div className="message">
        <InfoOutline />{' '}
        <span>
          If you are working on a specific sales opportunity, please provide DR
          number.
        </span>
      </div>
    </div>
  );
}
